module.exports = __webpack_public_path__ + "static/media/mark-as-read.68271120.svg";